var Backbone = require('backbone');
var _ = require('underscore');

var Section = require('front/pages/Section/Section');
var IndexPopup = require('front/pages/Index/IndexPopup');
var BuyCommercialPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var BuyFlatPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var BuyHousePopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var BuyRoomPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var SellCommercialPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var SellFlatPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var SellHousePopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var SellRoomPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var LetCommercialPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var LetOthersPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var RentCommercialPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var RentOthersPopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var OhMyGodPopup = require('front/pages/OhMyGod/OhMyGodPopup');
var UrgentSellPopup = require('front/pages/UrgentSell/UrgentSellPopup');
var MortgagePopup = require('front/pages/ServiceCommon/ServiceCommonPopup');
var ObjectPopup = require('front/pages/Object/ObjectPopup');
var FeedbackPopup = require('front/pages/Feedback/FeedbackPopup');
var NotFound = require('front/pages/NotFound/NotFound');

module.exports = Backbone.Router.extend({
    routes: {
        '': 'index',
        'buy/commercial/': 'buyCommercial',
        'buy/flat/': 'buyFlat',
        'buy/house/': 'buyHouse',
        'buy/room/': 'buyRoom',
        'sell/commercial/': 'sellCommercial',
        'sell/flat/': 'sellFlat',
        'sell/house/': 'sellHouse',
        'sell/room/': 'sellRoom',
        'let/commercial/': 'letCommercial',
        'let/flat-room-house/': 'letOthers',
        'rent/commercial/': 'rentCommercial',
        'rent/flat-room-house/': 'rentOthers',
        'oh-my-god/': 'ohMyGod',
        'urgent-sell/': 'urgentSell',
        'mortgage/': 'mortgage',
        'object/:id/': 'object',
        'feedback/': 'feedback'
    },

    index: function () {
        this.activate(Section, {view: IndexPopup, isIndex: true});
    },

    buyCommercial: function () {
        this.activate(Section, {
            view: BuyCommercialPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/buy/commercial/'
        });
    },

    buyFlat: function () {
        this.activate(Section, {view: BuyFlatPopup, isIndex: false, activateSubNav: true, apiUrl: '/api/buy/flat/'});
    },

    buyHouse: function () {
        this.activate(Section, {view: BuyHousePopup, isIndex: false, activateSubNav: true, apiUrl: '/api/buy/house/'});
    },

    buyRoom: function () {
        this.activate(Section, {view: BuyRoomPopup, isIndex: false, activateSubNav: true, apiUrl: '/api/buy/room/'});
    },

    sellCommercial: function () {
        this.activate(Section, {
            view: SellCommercialPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/sell/commercial/'
        });
    },

    sellFlat: function () {
        this.activate(Section, {view: SellFlatPopup, isIndex: false, activateSubNav: true, apiUrl: '/api/sell/flat/'});
    },

    sellHouse: function () {
        this.activate(Section, {
            view: SellHousePopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/sell/house/'
        });
    },

    sellRoom: function () {
        this.activate(Section, {view: SellRoomPopup, isIndex: false, activateSubNav: true, apiUrl: '/api/sell/room/'});
    },

    letCommercial: function () {
        this.activate(Section, {
            view: LetCommercialPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/let/commercial/'
        });
    },

    letOthers: function () {
        this.activate(Section, {
            view: LetOthersPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/let/flat-room-house/'
        });
    },

    rentCommercial: function () {
        this.activate(Section, {
            view: RentCommercialPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/rent/commercial/'
        });
    },

    rentOthers: function () {
        this.activate(Section, {
            view: RentOthersPopup,
            isIndex: false,
            activateSubNav: true,
            apiUrl: '/api/rent/flat-room-house/'
        });
    },

    ohMyGod: function () {
        this.activate(Section, {view: OhMyGodPopup, isIndex: false});
    },

    urgentSell: function () {
        this.activate(Section, {view: UrgentSellPopup, isIndex: false});
    },

    mortgage: function () {
        this.activate(Section, {view: MortgagePopup, isIndex: false, apiUrl: '/api/mortgage/'});
    },

    object: function (id) {
        this.activate(Section, {view: ObjectPopup, isIndex: false, apiUrl: '/api/object/' + id + '/'});
    },

    feedback: function () {
        this.activate(Section, {view: FeedbackPopup, isIndex: false});
    },

    notFound: function () {
        this.activate(NotFound);
    },

    activate: function (view, params) {
        params = params || {};

        $(window).scrollTop(0);

        if (params.activateSubNav) app.vent.trigger('activateSubPage');
        else app.vent.trigger('deactivateSubPage');

        if (params.isIndex) app.vent.trigger('activateIndex');
        else app.vent.trigger('deactivateIndex');

        // вьюха отрендерена на сервере
        if (!app.state.view) {
            params.server = true;

            app.state.view = new view(params);
            app.state.view.activate();

            if (params.activateSubNav) app.views.sideNav.trigger('activateSubNav');

            return;
        }

        app.state.prevView = app.state.view;

        this.activateSectionLogic(view, params);
    },

    // активация перехода с полной перезагрузкой и лоадером
    activateStandardLogic: function (view, params) {
        var newParams = _.defaults({server: false, inAnimated: true}, params);
        var newView = new view(newParams);
        // var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;

        return Promise.all([app.state.view.playOut({
            // duration: duration,
            // zoom: params.zoomNavigate,
            view: newView
        }), newView.loadData()])
            .then(function () {
                app.els.$content.css({minHeight: app.els.$content.height()});

                return app.state.view.deactivate({destroy: true});
            })
            .then(function () {
                app.state.isServer = false;
                app.state.view = newView;
                app.state.view.activate(newParams)
                    .then(function () {
                        app.els.$content.css({minHeight: ''});
                        $(window).scrollTop(0);

                        return app.state.view.playIn({
                            // duration: duration,
                            // zoom: params.zoomNavigate,
                            view: newView
                        });
                    });
            });

    },

    activateSectionLogic: function (view, viewParams) {
        var view = viewParams.view;
        var params = _.omit(viewParams, 'view');
        params.server = false;
        params.inAnimated = true;
        if (viewParams.apiUrl) {
            params.viewData = {
                apiUrl: viewParams.apiUrl
            };
        }

        app.state.view.update(view, params);
    },

    start: function () {
        var is404 = app.els.$body.hasClass('Page404');
        var pushStateSupported = history && _.isFunction(history.pushState);
        Backbone.history.start({pushState: pushStateSupported, silent: is404});

        if (is404) {
            this.notFound();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/Router.js
// module id = 33
// module chunks = 0